// @flow
import { useReducer } from 'react';

export type ModalState = {
  currentModal: ?('select_widget' | 'select_basic' | 'edit_preset' | 'edit_widget'),
  props: {
    slotId?: ?string,
    componentPosition?: ?number,
    subcomponentId?: ?string,
    widgetId?: ?string,
    initialPresetId?: ?string,
    subcomponentParentId?: ?string,
    subcomponentPosition?: ?number,
    insertIndex?: ?number,
  },
}

const modalReducer = (state: ModalState, action) => {
  switch (action.type) {
    case 'select_basic':
    case 'edit_preset':
    case 'edit_widget': {
      const currentModal = action.type;
      const props = action.payload;

      return {
        ...state,
        currentModal,
        props
      };
    }
    case 'select_widget': {
      const currentModal = action.type;

      return {
        ...state,
        currentModal
      };
    }
    case 'reset': {
      return {
        ...state,
        currentModal: null,
        props: {}
      };
    }
    default:
      throw new Error('Invalid modal update');
  }
};

const useEditorModal = () => {
  const [modalState = {}, dispatchModalUpdate] = useReducer(modalReducer, { currentModal: null, props: {}});

  const { currentModal, props: currentModalProps } = modalState;

  const showSelectBasicModal = (slotId: string, componentPosition: ?number, subcomponentParentId: ?string, subcomponentPosition: ?number, insertIndex: ?number) => {
    dispatchModalUpdate({
      type: 'select_basic',
      payload: {
        slotId,
        componentPosition,
        subcomponentParentId,
        subcomponentPosition,
        insertIndex
      }
    });
  };

  const showEditPresetModal = (slotId: string, componentPosition: number, widgetId: string, initialPresetId: ?string) => {
    dispatchModalUpdate({
      type: 'edit_preset',
      payload: {
        slotId,
        componentPosition,
        widgetId,
        initialPresetId
      }
    });
  };

  const showEditWidgetModal = (slotId: string, componentPosition: number, subcomponentId: ?string) => {
    dispatchModalUpdate({
      type: 'edit_widget',
      payload: {
        slotId,
        componentPosition,
        subcomponentId
      }
    });
  };

  const showSelectWidgetModal = () => {
    dispatchModalUpdate({ type: 'select_widget' });
  };

  const resetModal = () => {
    dispatchModalUpdate({ type: 'reset' });
  };

  return {
    // Data
    currentModal,
    currentModalProps,

    // Functions
    showSelectBasicModal,
    showEditPresetModal,
    showEditWidgetModal,
    showSelectWidgetModal,
    resetModal
  };
};

export default useEditorModal;
